import { css, SerializedStyles } from '@emotion/core';
import { Theme, helpText, normalText } from 'features/Theme';

const style = {
  titleText: (theme: Theme) => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  normalText: (theme: Theme) => css`
    ${normalText(theme)}
  `,
  headingContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,

  ccpaDisclosure: (theme: Theme): SerializedStyles => css`
    ${helpText(theme)};
    color: ${theme.mui.palette.text.secondary};
    margin: ${theme.mui.spacing(3)}px 0;
  `,

  formFields: (theme: Theme) => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,

  disclosureBox: (theme: Theme): SerializedStyles => css`
    ${helpText(theme)};
    margin: ${theme.mui.spacing(2)}px 0;
  `,

  finePrint: (theme: Theme): SerializedStyles => css`
    ${helpText(theme)};
    color: ${theme.mui.palette.text.secondary};
    margin-top: ${theme.mui.spacing(1)}px;
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
};

export default style;
